'use strict';

/**
 * Validates a national registration number.
 * @param nrn The number to validate
 * @returns {boolean} True if valid.
 */
function validateNRN (nrn) {
  if (nrn.length !== 11) {
    return false;
  }
  const calcnum = 97;
  const numpre = Number(nrn.substr(0, 9));
  const numpost = Number(`2${nrn.substr(0, 9)}`);
  const check = Number(nrn.substr(9, 11));
  return ((calcnum - (numpre % calcnum) === check) || (calcnum - (numpost % calcnum) === check));
}

/**
 * Adds spaces on the appropriate places in the national number,
 * taking in account that it can have an year prefix
 * @param {string} nrn
 * @returns {string}
 */
function formatRnr (nrn) {
  if (nrn) {
    const trimmedNrn = nrn.replace(/\s/g, '');
    if (trimmedNrn.length === 13) {
      const prefix = trimmedNrn.slice(0, 2);
      if (prefix === '19' || prefix === '20') {
        const shortNrn = formatRnr(trimmedNrn.slice(2));
        if (shortNrn) {
          return `${prefix}${shortNrn}`;
        }
      }
    }
    if (trimmedNrn.length === 11 && validateNRN(trimmedNrn)) {
      return trimmedNrn.replace(/^(.{6})(.{3})(.{2})$/, '$1 $2 $3');
    }
  }
  return '';
}

/**
 * Formats the NRN to the technical format YYMMDDXXXYY (no spaces, no leading century)
 * @param nrn The unformatted nrn
 * @returns {string|*} The formatted nrn
 */
function formatNrnTechnically (nrn) {
  if (!nrn) return nrn;
  const noSpacesNrn = nrn.replace(/\D/g, '');
  return noSpacesNrn.length === 13 ? noSpacesNrn.substring(2) : noSpacesNrn;
}

module.exports = { formatRnr, formatNrnTechnically, validateNRN };
